import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { purchaseBuyMore, selectBuyMore, setSelectedProduct } from '@app/redux/buyMore';

import CheckoutError from './CheckoutError';
import CheckoutLoading from './CheckoutLoading';
import CheckoutSuccess from './CheckoutSuccess';
import CheckoutTransactionError from './CheckoutTransactionError';
import { ErrorEnum } from '../utils/types';

type CheckoutContainerProps = {
  isModalOpen: boolean;
  handleClose: (isSuccess: boolean, error?: ErrorEnum | undefined) => void;
};

const CheckoutContainer = ({ isModalOpen, handleClose }: CheckoutContainerProps): JSX.Element | null => {
  const dispatch = useDispatch();

  const { transactionLoading, transactionError, purchaseSuccessful, selectedProduct } = useSelector(selectBuyMore);

  useEffect(() => {
    if (selectedProduct?.id) {
      dispatch(
        purchaseBuyMore({
          productTypeId: selectedProduct?.id,
          planName: selectedProduct?.description,
        })
      );
    }
  }, [dispatch, selectedProduct?.description, selectedProduct?.id]);

  useEffect(() => {
    if (!isModalOpen) {
      dispatch(setSelectedProduct(null));
    }
  }, [dispatch, isModalOpen]);

  if (!selectedProduct) {
    return null;
  }

  if (transactionLoading) {
    return <CheckoutLoading isOpen={isModalOpen} />;
  }

  // When API returns 200 but success is false
  if (purchaseSuccessful === false) {
    return <CheckoutError handleClose={handleClose} isModalOpen={isModalOpen} />;
  }

  // When transaction returns an error
  if (transactionError) {
    return <CheckoutTransactionError handleClose={handleClose} isModalOpen={isModalOpen} />;
  }

  return <CheckoutSuccess isModalOpen={isModalOpen} dataAmount={selectedProduct.amount} handleClose={handleClose} />;
};

export default CheckoutContainer;
